import React from 'react';
import { LogoImg } from './elements';
import { PageWrapper, Container } from '@Main/elements';
import { P } from '@helpers';
import bg from '@static/about/sfx-bg_5.png';

export const Trust = ({t}) => {
    return (
      <PageWrapper darkMode={true} bgImage={bg} height="450px">
        <Container paddingTop='35px' marginLeft='102px' marginRight='35px'>
          <LogoImg/>
          <P weight='400' size='25px' height='30px' marginTop='30px'>{t("Trust is everything")}</P>
          <P weight='400' size='15px' height='30px' marginTop='40px' width="700px">
            {t("Building trust-based relationships with potential customers is one of our main priorities, and this is the top priority when creating content. Trust is our main asset, and we desire to demonstrate our expertise properly. Through content creation, we seek to provide the customer with honest and unbiased information about us and our products, and to establish an initial connection.")} 
          </P>
        </Container>
     </PageWrapper>
  );
};
